const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const branded = hostname.startsWith("getmydish");

const getMyDishConfig = {
  branded: true,
  showPopularCategories: false,
  showNewLaunchedBrands: false,
  showTrendingProducts: false,
  showPopularBrands: false,
  showPopularProducts: false,
  appName: "Get My Dish",
  appLink:"https://getmydish.com",
  businessApp:"Get My Dish",
  companyName:"Get My Dish",
  businessAppLink:"https://getmydish.com",
  appHome: "Restaurants",
  exeName: "Get-My-Dish",
  logoLight: "https://jhattse.com/api/v1/file/?key=brand/FQ5GZ249/GetmyDish_a1.png",
  logoDark: "https://jhattse.com/api/v1/file/?key=brand/FQ5GZ249/GetmyDish_a1.png",
  logoV2: "https://jhattse.com/api/v1/file/?key=brand/FQ5GZ249/GetmyDish_a1.png",
  icon: "https://business.jhattse.com/business/light_favicon.png",
  signupImage: "https://jhattse.com/api/v1/file/?key=jhattse/O7HS8RQ0_LP.png",
  gitHubUrlPrefix: "Get-My-Dish",
  poweredBy: "Get-My-Dish",
  appUrl: "https://play.google.com/store/apps/details?id=com.jhattse.pms&pli=1",
  accountId: 79127,
  phone: "+919441914390",
  email: "info@getmydish.com",
  twitter: null as string,
  facebook: null as string,
  instagram: null as string,
  mapPin: null as string,
  partnerWithUs: null as string,
  sellOnPlatform: null as string,
  sellOnPlatformLink: null as string,
  blog: null as string,
  cin: "",
  gstin: "",
  registeredAddress: ""
};

const defaultConfig = {
  branded: false,
  showPopularCategories: true,
  showNewLaunchedBrands: true,
  showTrendingProducts: true,
  showPopularBrands: true,
  showPopularProducts: true,
  appName: "Jhattse",
  appHome: "Jhattse",
  appLink:"https://jhattse.com",
  companyName:"Esangrah Technologies Pvt Ltd",
  businessApp:"Jhattse Business",
  businessAppLink:"https://business.jhattse.com",
  exeName: "Jhattse",
  logoLight: "public/jhattse-logo.svg",
  logoDark: "business/jhattse-linear.webp?v=5",
  logoV2: "public/jhattse-logo.svg?v=10",
  icon: "https://business.jhattse.com/business/light_favicon.png",
  signupImage: "https://jhattse.com/api/v1/file/?key=jhattse/O7HS8RQ0_LP.png",
  gitHubUrlPrefix: "master",
  poweredBy: "Esangrah Technologies Pvt. Ltd.",
  appUrl: "https://play.google.com/store/apps/details?id=com.jhattse.business.twa&utm_source=web&utm_campaign=app_download&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
  accountId: null as number,
  phone: "+917310722298",
  email: "connect@jhattse.com",
  twitter: "https://twitter.com/jhattse",
  facebook: "https://www.facebook.com/profile.php?id=100088066437195",
  instagram: "https://www.instagram.com/jhattse/",
  mapPin: `https://www.google.com/maps/place/ESANGRAH+TECHNOLOGIES+PRIVATE+LIMITED/@30.2977277,78.0679105,17z/data=!3m1!4b1!4m6!3m5!1s0x390929a02dbc9563:0x483f9a088c2712a1!8m2!3d30.2977231!4d78.0700992!16s%2Fg%2F11sjgmr_fg`,
  partnerWithUs: "https://business.jhattse.com/signup",
  sellOnPlatform: "jhattse Business",
  sellOnPlatformLink: "https://business.jhattse.com/products/seller-software-for-brands",
  blog: "/business-and-brand-stories",
  // Shown on the About pages once filled in. Leave empty until confirmed.
  cin: "U72900UR2023PTC015183",
  gstin: "05AAHCE4252A1Z7",
  registeredAddress: "Natthanpur, Dehradun, Uttarakhand 248005"
};

const appConfig = branded ? getMyDishConfig : defaultConfig;

export default appConfig;
